import { motion } from "framer-motion";
import styled from "styled-components/macro";

export const CardStackContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-self: start;
  height: 343px;
  isolation: isolate;
`;

export const CardLayer = styled(motion.div)`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
`;
